import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';
import Background from './Background';
import Heading from './Heading';
import Content from './Content';
import Button from './Button';
import { setClassNames } from '../utilities/classes';

const ContentWrapper = ({
	widgetConfiguration,
	windowId,
	isClickableDivElement,
	headingText,
	contentText,
	buttonText,
	dialogWindowTitleText,
	target
}) => {
	const {
		widgetAlignment,
		widgetJustify,
		widgetMargin,
		widgetPadding,
		textAlignment,
		contentWrapperWidth,
		contentWrapperTransitionProperty,
		contentWrapperTransitionTimingFunction,
		contentWrapperTransitionDuration,
		buttonTransitionProperty,
		buttonTransitionTimingFunction,
		buttonTransitionDuration,
		textColor,
		imageLocation,
		enableContentOverflowHidden
	} = widgetConfiguration;

	return (
		<div
			className={setClassNames(
				'cta-content',
				'd-flex',
				'flex-column',
				'h-100',
				'position-relative',
				widgetAlignment,
				widgetJustify,
				widgetMargin,
				widgetPadding,
				textAlignment,
				textColor,
				contentWrapperWidth,
				contentWrapperTransitionProperty,
				contentWrapperTransitionTimingFunction,
				contentWrapperTransitionDuration
			)}
			style={enableContentOverflowHidden ? { overflow: 'hidden' } : null}
		>
			<Icon {...widgetConfiguration} />
			{imageLocation === 'foreground' && (
				<Background {...widgetConfiguration} />
			)}
			<Heading {...{ ...widgetConfiguration, headingText }} />
			<Content {...{ ...widgetConfiguration, contentText }} />
			<Button
				{...{
					...widgetConfiguration,
					windowId,
					isClickableDivElement,
					target,
					dialogWindowTitleText,
					buttonText,
					buttonTransitionProperty,
					buttonTransitionTimingFunction,
					buttonTransitionDuration
				}}
			/>
		</div>
	);
};

ContentWrapper.defaultProps = {
	headingText: '',
	contentText: '',
	buttonText: '',
	dialogWindowTitleText: ''
};

ContentWrapper.propTypes = {
	widgetConfiguration: PropTypes.shape({
		widgetAlignment: PropTypes.string.isRequired,
		widgetJustify: PropTypes.string.isRequired,
		widgetMargin: PropTypes.string.isRequired,
		widgetPadding: PropTypes.string.isRequired,
		textAlignment: PropTypes.string.isRequired,
		contentWrapperWidth: PropTypes.string.isRequired,
		contentWrapperTransitionProperty: PropTypes.string.isRequired,
		contentWrapperTransitionTimingFunction: PropTypes.string.isRequired,
		contentWrapperTransitionDuration: PropTypes.string.isRequired,
		buttonTransitionProperty: PropTypes.string.isRequired,
		buttonTransitionTimingFunction: PropTypes.string.isRequired,
		buttonTransitionDuration: PropTypes.string.isRequired,
		textColor: PropTypes.string.isRequired,
		imageLocation: PropTypes.string.isRequired,
		enableContentOverflowHidden: PropTypes.bool.isRequired
	}).isRequired,
	windowId: PropTypes.string.isRequired,
	isClickableDivElement: PropTypes.bool.isRequired,
	target: PropTypes.string.isRequired,
	headingText: PropTypes.string,
	contentText: PropTypes.string,
	buttonText: PropTypes.string,
	dialogWindowTitleText: PropTypes.string
};

export default ContentWrapper;



// WEBPACK FOOTER //
// ./src/components/ContentWrapper.jsx